import * as E from 'fp-ts/es6/Either'
import * as TE from 'fp-ts/es6/TaskEither'
import { pipe, identity } from 'fp-ts/es6/function'
import axios, { AxiosError } from 'axios'
import { CrowdSurfConfig } from './appconfig'
import { CSRFToken } from './fed_api_gateway_csrf_helper'

export type UserInfoFetchError = 'UnknownUserFetchError' | 'UnauthenticatedUserFetchError'
export type UserInfo = {
  userEmail: string
}

export const teGetUserInfo = ({ authentication }: CrowdSurfConfig, csrfToken: CSRFToken): TE.TaskEither<UserInfoFetchError, UserInfo> =>
  pipe(
    TE.tryCatch(
      () =>
        axios(authentication.apiEndpoint, {
          method: 'POST',
          headers: {
            'Amazon-Advertising-API-AdvertiserId': '',
            'Amazon-Advertising-API-ClientId': authentication.apiClientId,
            'Amazon-Advertising-API-MarketplaceId': authentication.apiMarketplaceId,
            'Amazon-Advertising-API-CSRF-Data': authentication.apiClientId,
            'Amazon-Advertising-API-CSRF-Token': csrfToken,
          },
          data: {
            operationName: 'CrowdSurfWhoAmI',
            query: 'query CrowdSurfWhoAmI { whoAmI { userEmail }}',
          },
          withCredentials: true,
        }),
      identity,
    ),
    TE.chainEitherK((success: { data?: { data?: { whoAmI?: { userEmail: string } } } }) => {
      if (success?.data?.data?.whoAmI?.userEmail) {
        return E.right({ userEmail: success?.data?.data?.whoAmI?.userEmail })
      } else {
        return E.left('Unexpected Error parsing UserEmail')
      }
    }),
    TE.mapLeft((error: unknown) => {
      if (
        (error as AxiosError).code === '401' ||
        ((error as AxiosError)?.message && (error as AxiosError)?.message.indexOf('401') > 0) ||
        (error as AxiosError).code === '500'
      ) {
        // This is where we will end up if the user is not authenticated (has valid AuthPortal cookies, either at-tacbus or at-main)
        return 'UnauthenticatedUserFetchError' as UserInfoFetchError
      } else {
        // We're treating unknown CSRF errors as un-authenticated since there is no remedy for UnknownCSRF errors.
        return 'UnknownUserFetchError' as UserInfoFetchError
      }
    }),
  )
